// libs
import { motion, Variants } from "framer-motion";
import styled from "styled-components";
// other
import { PAGE_TRANSITION_DURATION } from "../data/animationConfig";

interface PageTranisitionProps {
  animateIn?: boolean;
  animateOut?: boolean;
}

const Wrapper = styled(motion.div)`
  height: 100%;
`;

const Inner = styled(motion.div)`
  height: 100%;
`;

const innerVariants: Variants = {
  initial: { opacity: 0, scale: 1 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 1 },
};

export const PageTransition: React.FC<PageTranisitionProps> = ({
  animateIn = true,
  animateOut = true,
  children,
}) => {
  return (
    <Wrapper>
      <Inner
        initial={animateIn ? "initial" : false}
        animate="animate"
        exit={animateOut ? "exit" : {}}
        variants={innerVariants}
        transition={{ duration: PAGE_TRANSITION_DURATION, type: "tween" }}
      >
        {children}
      </Inner>
    </Wrapper>
  );
};
